import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PageSkeleton } from './shared/components/page-skeleton/page-skeleton';
import { tinboHandoffActive } from './shared/utils/tinbo-handoff.ui';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PageSkeleton],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly tinboHandoffActive = tinboHandoffActive();
}
